// extracted by mini-css-extract-plugin
module.exports = {"commentDiv":"commentsbox_commentDiv__23Y4d","inp":"commentsbox_inp__10k8y","buttonSubmit":"commentsbox_buttonSubmit__B9tOi"};